import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { getAttendanceSchemaMulti } from '../../../redux/actions/multiReview'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import AttendanceRecordForm from '../../../widgets/attendanceRecord/AttendanceRecordWidget'

export default function AttendanceRecordSingle() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    const request = {
      id: projectId,
    }

    handleGetSchema(request)
  }, [])

  const handleGetSchema = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getAttendanceSchemaMulti(request)
      setSchema(response)
    } catch (e) {
      console.log('e', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      {schema?.forms?.expertList && (
        <>
          <AttendanceRecordForm schema={schema.forms.expertList} isSingle={true} />
          <br />
        </>
      )}
    </SidebarProposal>
  )
}
